const initialState = {
    getProjectListCallStarted : false,
    getProjectListCallSuccess : false,
    getProjectListCallFailure : false,
    projectList : [],
    isLoading: false,
}

export default initialState
